import { Component } from 'react'
import PropTypes from 'prop-types'

class BlankErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    componentDidCatch() {
        this.setState({ hasError: true })
    }

    render() {
        if (this.state.hasError) {
            return null
        }
        return this.props.children
    }
}

BlankErrorBoundary.propTypes = {
    children: PropTypes.node,
}

BlankErrorBoundary.defaultProps = {
    children: null,
}

export default BlankErrorBoundary



// WEBPACK FOOTER //
// /src/js/common/errorBoundaries/BlankErrorBoundary.jsx